<div class="dashboard-container" data-testid="dashboard-container">
  <span data-testid="welcome-label">Welcome, </span>
  <span id="username" data-testid="username">{{ userName }}</span>

  <div class="report-grid" data-testid="report-grid">
    <div class="report-card" data-testid="report-card-production-overview">
      <div class="report-title" data-testid="report-title-production-overview">
        PRODUCTION OVERVIEW
      </div>
      <button
        class="view-button"
        (click)="navigateToProductionOverview()"
        data-testid="view-button-production-overview"
      >
        View report
      </button>
    </div>

    <div class="report-card" data-testid="report-card-employee-reports">
      <div class="report-title" data-testid="report-title-employee-reports">
        EMPLOYEE REPORT
      </div>
      <button
        class="view-button"
        (click)="navigateToEmpReport()"
        data-testid="view-button-employee-reports"
      >
        View report
      </button>
    </div>

    <div class="report-card" data-testid="report-card-top-performers">
      <div class="report-title" data-testid="report-title-top-performers">
        TOP PERFORMER
      </div>
      <button
        class="view-button"
        (click)="navigateToTopPerformer()"
        data-testid="view-button-top-performers"
      >
        View report
      </button>
    </div>

    <div class="report-card">
      <div class="report-title">SELL THROUGH REPORT</div>
      <button
        class="view-button"
        (click)="navigateToSellThroughReport()"
        data-testid="view-button-sell-through-reports"
      >
        View report
      </button>
    </div>
    <div class="report-card">
      <div class="report-title">SALES PRODUCTIVITY REPORT</div>
      <button
        class="view-button"
        (click)="navigateToSalePerProducerReport()"
        data-testid="view-button-sale-per-producer-report"
      >
        View report
      </button>
    </div>
  </div>
</div>
